//仓库类型
export enum WarehouseSiteType {
    HUB = "HUB",
    WAREHOUSE = "WAREHOUSE"
}